import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

import MenuContent, {
  EXPANDED_SIDEBAR_WIDTH,
  FIGMA_SIDEBAR_HEIGHT,
  SIDEBAR_CONTENT_GAP,
} from "./MenuContent";
import { useAuth } from "../../../../app/providers/AuthProvider";

function getMobileScale() {
  if (typeof window === "undefined") return 0.88;
  const heightScale = window.innerHeight / FIGMA_SIDEBAR_HEIGHT;
  return Math.min(0.9, Math.max(0.84, heightScale));
}

export default function SideMenuMobile({ open, toggleDrawer }) {
  const { isAuthenticated } = useAuth();
  const [scale, setScale] = React.useState(getMobileScale);
  const sidebarWidth = EXPANDED_SIDEBAR_WIDTH * scale;
  const drawerWidth = `min(${sidebarWidth + SIDEBAR_CONTENT_GAP * scale}px, 100vw)`;

  React.useEffect(() => {
    function syncScale() {
      setScale(getMobileScale());
    }

    syncScale();
    window.addEventListener("resize", syncScale);
    return () => window.removeEventListener("resize", syncScale);
  }, []);

  if (!isAuthenticated) return null;

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={toggleDrawer(false)}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: "block", md: "none" },
        [`& .MuiDrawer-paper`]: {
          backgroundColor: "transparent",
          border: 0,
          boxShadow: "none",
          overflow: "visible",
          transition: "width 220ms ease",
          width: drawerWidth,
        },
      }}
    >
      <Box
        sx={{
          height: "100vh",
          width: `${sidebarWidth}px`,
        }}
      >
        <MenuContent
          expanded
          scale={scale}
          onItemClick={toggleDrawer(false)}
        />
      </Box>
    </Drawer>
  );
}
